/**
 * Calendar arithmetic in UTC fields, which no daylight-saving transition moves,
 * so the cutoff lands on the same instant whatever timezone the caller runs in.
 */
export function calendarMonthsBefore(now: Date, months: number): Date {
  const cutoff = new Date(now.getTime());
  const dayOfMonth = cutoff.getUTCDate();

  cutoff.setUTCMonth(cutoff.getUTCMonth() - months);

  if (cutoff.getUTCDate() !== dayOfMonth) {
    // Day zero of the month the overflow landed in is the last day of the month
    // it was meant to land in.
    cutoff.setUTCDate(0);
  }

  return cutoff;
}
